import { sleep } from '@moniebook-web/utils';
import { CUSTOM_EVENTS } from '../../events';
import { revalidateStockDetails } from '../../item-stock';
import { checkIfSignedInAndOnline } from '../utils';

export const MINIMUM_STOCK_REQUEST_DURATION = 2_500;

export async function itemStockSyncJobHandler() {
    const shouldRun = checkIfSignedInAndOnline();

    if (!shouldRun) {
        return;
    }

    try {
        globalThis.window.dispatchEvent(
            new CustomEvent(CUSTOM_EVENTS.ITEM_STOCK_SYNC_STARTED),
        );

        await Promise.all([
            revalidateStockDetails(true),
            sleep(MINIMUM_STOCK_REQUEST_DURATION),
        ]);

        globalThis.window.dispatchEvent(
            new CustomEvent(CUSTOM_EVENTS.ITEM_STOCK_SYNC_SUCCESS),
        );
    } catch {
        await sleep(MINIMUM_STOCK_REQUEST_DURATION);

        globalThis.window.dispatchEvent(
            new CustomEvent(CUSTOM_EVENTS.ITEM_STOCK_SYNC_FAILED),
        );
    }
}
